// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import {
  TwitterBadge,
  FacebookBadge,
  LinkedInBadge,
  CompanyLinkedInBadge,
  GitHubBadge,
} from "../SocialBadge"

interface Props {
  containerStyle?: string
  listStyle?: string
  listItemStyle?: string
  iconSize?: string
  facebookHandle?: string
  twitterHandle?: string
  githubHandle?: string
  linkedinHandle?: string
  companyLinkedinHandle?: string
}

const BadgeItem = ({ style, children }) => {
  return <li className={style}>{children}</li>
}

export const SocialBadgeList: React.FC<Props> = ({
  listStyle,
  listItemStyle,
  iconSize,
  twitterHandle,
  facebookHandle,
  githubHandle,
  linkedinHandle,
  companyLinkedinHandle,
}: Props) => {
  return (
    <ul className={listStyle}>
      {twitterHandle && (
        <BadgeItem style={listItemStyle}>
          <TwitterBadge handle={twitterHandle} size={iconSize} />
        </BadgeItem>
      )}
      {facebookHandle && (
        <BadgeItem style={listItemStyle}>
          <FacebookBadge handle={facebookHandle} size={iconSize} />
        </BadgeItem>
      )}
      {linkedinHandle && (
        <BadgeItem style={listItemStyle}>
          <LinkedInBadge handle={linkedinHandle} size={iconSize} />
        </BadgeItem>
      )}
      {companyLinkedinHandle && (
        <BadgeItem style={listItemStyle}>
          <CompanyLinkedInBadge
            handle={companyLinkedinHandle}
            size={iconSize}
          />
        </BadgeItem>
      )}
      {githubHandle && (
        <BadgeItem style={listItemStyle}>
          <GitHubBadge handle={githubHandle} size={iconSize} />
        </BadgeItem>
      )}
    </ul>
  )
}

export default SocialBadgeList
